import {Pipe, PipeTransform} from '@angular/core';
import {ERateType} from "../../../../../service/resources/booking/interfaces/get-bookings.enum";

@Pipe({
    name: 'computeRate'
})
export class ComputeRatePipe implements PipeTransform {
    public transform(rateTitle: string): ERateType {
        if(!rateTitle){
            return undefined;
        }
        const rateValue: string = rateTitle.split(" ")[0].toLowerCase();
        switch (rateValue) {
            case ERateType.Fee.toLowerCase():
                return ERateType.Fee;
            case ERateType.Service.toLowerCase():
                return ERateType.Service;
            case ERateType.Transportation.toLowerCase():
                return ERateType.Transportation;
            default:
                return undefined;
        }
    }
}
